export default {
    "Decentralization":"분권화",
        "Coin-based":"코인 기반",
        "Perpetual Options": "영구 옵션",
        "Future Derivatives Infrastructure": "미래 파생상품 인프라",
        "Start Trading":"거래 시작",
        "Follow":"카피 트레이딩",
        "Trading":"거래",
        "Fund Pool":"펀드 풀",
        "Recommendation Reward": "추천 보상",
        "Language": "언어",
        "Never Liquidate": "절대 청산하지 마십시오",
        "Eliminate Liquidation Risk":"청산 위험 제거",
        "Risk Management Easier": "위험 관리가 더 쉬워졌습니다",
        "High Leverage": "하이 레버리지",
        "Multiple Leverage":"다중 레버리지",
        "High Profit Potential": "높은 이익 잠재력",
        "Zero Slippage":"제로 미끄러짐",
        "Execution Price Meets Expected Results": "실행 가격이 예상 결과를 충족합니다",
        "Eliminate Impermanent Loss": "무상한 손실을 제거하다",
        "Commission Rate 15%":"수수료율 50%",
        "Generous recommendation rewards, recognize your contribution":"관대한 추천 보상, 당신의 기여를 인정합니다",
        "Generous recommendation rewards, recognize your contribution2":"관대한 추천 보상<br/>당신의 기여를 인정합니다",
        "Invite a friend":"친구 초대",
        "Invite a friend to Fufuture via a referral link":"추천 링크를 통해 친구를 Fufuture에 초대하세요",
        "Friend completes first order":"친구가 첫 번째 주문을 완료했습니다",
        "Friend accepts invitation and completes first order":"친구가 초대를 수락하고 첫 번째 주문을 완료합니다",
        "Get your commission": "수수료를 받으세요",
        "Get your commission immediately and claim it anytime":"즉시 수수료를 받고 언제든지 청구하세요",
        "Create my link": "내 링크 만들기",
        "Deep liquidity supported by dual pools":"듀얼 풀이 지원하는 깊은 유동성",
        "Public pool":"공공 수영장",
        "Available liquidity":"사용 가능한 유동성",
        "Private pool":"개인 풀",
        "Add LP":"LP 추가",
        "FAQ":"자주 묻는 질문",
        "Future Derivatives Infrastructure2":"미래 파생상품 인프라",
        "Dual liquidity pool":"듀얼 유동성 풀",
        "Open liquidity pool":"열린 유동성 풀",
        "More stable liquidity":"더욱 안정적인 유동성",
        "Reasonable pricing": "합리적인 가격",
        "Price feed from third-party oracle":"제3자 오라클의 가격 피드",
        "Precise error control":"정밀한 오류 제어",
        "BTC 24-hour trading volume summary":"BTC 24시간 거래량 요약",
        "BTC holdings summary":"BTC 보유량 요약",
        "ETH 24-hour trading volume summary":"ETH 24시간 거래량 요약",
        "ETH holdings summary":"ETH 보유량 요약",
    "q1":"내 계정 보안을 어떻게 강화할 수 있습니까?",
    "a1": "지갑을 통해 거래 웹사이트에 들어가고, 개인 비밀 키를 보호하고, 피싱 링크를 클릭하거나 알 수 없는 QR 코드를 스캔하지 마십시오.",
    "q2":"어떻게 돈을 입금합니까?",
    "a2": "미래에 대상 토큰이 위치한 퍼블릭 체인을 선택하고 입금 작업을 위한 대상 토큰을 선택하세요.",
    "q3":"선물거래 수수료는 얼마입니까?",
    "a3":"영구 옵션은 포지션을 개설할 때 1‰만 부과됩니다."

}
